/*
  Плитки листов реестра - вариант А1, выбранный владельцем 05.10.2026.

  🔴 Способ загрузки - свойство ЛИСТА, а не его названия (замечание владельца:
  «не у всех будут такие листы и так названы»). Сервер предлагает способ по
  словам в названии и по отметкам о суде и объясняет почему; человек может
  выбрать другой - и тогда предпросмотр пересчитывается тем же запросом, что
  потом запишет файл.

  Плитки показываются, только когда листов больше одного: главным остаётся
  первый лист, и однолистный реестр выглядит как раньше (решение владельца).
*/

import { money } from '../api/format.js'
import Dropdown from './Select.jsx'

export const TREATMENTS = {
  plain: 'Загрузить как обычно',
  hold: 'Придержать до проверки',
  court_work: 'С отметками судебной работы УК',
}

function accounts(count) {
  const tail = count % 100
  if (tail >= 11 && tail <= 14) return `${count} счетов`
  const last = count % 10
  if (last === 1) return `${count} счёт`
  if (last >= 2 && last <= 4) return `${count} счёта`
  return `${count} счетов`
}

function SheetTile({ sheet, index, onChange, busy }) {
  // По номеру, а не по названию листа: в названии бывает пробел («На проверку»),
  // а `aria-labelledby` делит значение по пробелам - и подпись терялась.
  const labelId = `sheet-choice-${index}`
  const skipped = sheet.accounts === 0 && sheet.reason.startsWith('Лист пропущен')
  return (
    <div className="card sheet-tile">
      <div className="money__label">
        Лист «{sheet.title}» · {accounts(sheet.accounts)}
      </div>
      <div className="money__value">{money(sheet.debt_declared)}</div>
      {skipped ? null : (
        <div className="field sheet-tile__choice">
          <span className="field__label" id={labelId}>
            Как загрузить этот лист
          </span>
          <Dropdown
            value={sheet.treatment}
            onChange={(value) => onChange(sheet.title, value)}
            options={TREATMENTS}
            labelledBy={labelId}
            disabled={busy}
          />
        </div>
      )}
      <div className="money__note">{sheet.reason}</div>
    </div>
  )
}

export default function RegistrySheets({ sheets, onChange, busy }) {
  if (sheets.length < 2) return null
  return (
    <div className="grid grid--even sheet-tiles">
      {sheets.map((sheet, index) => (
        <SheetTile
          key={sheet.title}
          sheet={sheet}
          index={index}
          onChange={onChange}
          busy={busy}
        />
      ))}
    </div>
  )
}
